import {AppCtrl} from "./appctrl";

function start() {
    new AppCtrl();
}

export {start};